var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileSvg07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.75H2.25C1.85218 2.75 1.47064 2.90804 1.18934 3.18934C0.908035 3.47064 0.75 3.85218 0.75 4.25V13.25C0.75 13.6478 0.908035 14.0294 1.18934 14.3107C1.47064 14.592 1.85218 14.75 2.25 14.75H9.75C10.1478 14.75 10.5294 14.592 10.8107 14.3107C11.092 14.0294 11.25 13.6478 11.25 13.25V4.25C11.25 3.85218 11.092 3.47064 10.8107 3.18934C10.5294 2.90804 10.1478 2.75 9.75 2.75H8.25",
    stroke: "#182EA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.75V8M6 11.75V11M8.25 11.75V9.5M3.75 2.75C3.75 2.35218 3.90804 1.97064 4.18934 1.68934C4.47064 1.40804 4.85218 1.25 5.25 1.25H6.75C7.14782 1.25 7.52936 1.40804 7.81066 1.68934C8.09196 1.97064 8.25 2.35218 8.25 2.75C8.25 3.14782 8.09196 3.52936 7.81066 3.81066C7.52936 4.09196 7.14782 4.25 6.75 4.25H5.25C4.85218 4.25 4.47064 4.09196 4.18934 3.81066C3.90804 3.52936 3.75 3.14782 3.75 2.75Z",
    stroke: "#182EA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSvg07);
export default __webpack_public_path__ + "static/media/profile-svg07.d5fc391987ff1a695875a677d6d65b33.svg";
export { ForwardRef as ReactComponent };